import React, { useState, useEffect } from "react"
import { storageData } from "services/Services"
import { useLocation } from "react-router-dom";
import { useServerDate } from "services/ServerDateContext";

export const RemoveVehicleContext = React.createContext()

const getStateAbbr = (state) => {
    const statesMap = {
        "Michigan": "MI",
        "New Jersey": "NJ",
        "Pennsylvania": "PA"
    }

    return statesMap[state] || "";
}

// Removes changes for extra storage in local storage
const clear = () => {
    storageData.removeItem("drivers");
    storageData.removeItem("newDrivers");
    storageData.removeItem("members");
    storageData.removeItem("newMembers");
    storageData.removeItem("effectiveDate");
    storageData.removeItem("currResidence");
    storageData.removeItem("vehicleInfo");
    storageData.removeItem("PendingAddress");
    storageData.removeItem("PendingAddedDrivers");
    storageData.removeItem("PendingAddedHhms");
    storageData.removeItem("PendingRemovedDrivers");
    storageData.removeItem("PendingRemovedHhms");
    storageData.removeItem("PendingAddedVehicles");
    storageData.removeItem("PendingRemovedVehicles");
    storageData.removeItem("newResidenceData");
    storageData.removeItem("householdData");
    storageData.removeItem("additionalData");
    storageData.removeItem("driverAssignmentData");
    storageData.removeItem("summaryChanges");
    storageData.removeItem("updatedAddedDrivers");
    storageData.removeItem("AddressChangeConfirmationNumber");
    storageData.removeItem("updateHouseholdData");
    storageData.removeItem("householdAdditionalData");
    storageData.removeItem("householdSummaryChanges");
    storageData.removeItem("HouseholdChangeConfirmationNumber");
    storageData.removeItem("updateVehicleData");
    storageData.removeItem("updateDriverAssignmentData");
    storageData.removeItem("newVehicles");
    storageData.removeItem("dbVehicles");
    storageData.removeItem("vehicleSummaryChanges");
    storageData.removeItem("VehicleChangeConfirmationNumber");
    storageData.removeItem("storedDrivers");
    storageData.removeItem("storedHouseholdMembers");
    storageData.removeItem("storedVehicles");
    storageData.removeItem("LeasingList");
    storageData.removeItem("FinanceCompanyList");
    storageData.removeItem("LeasingListGW");
    storageData.removeItem("FinanceListGW");
    storageData.removeItem("VehicleChangeClass");
    storageData.removeItem("HouseholdChangeClass");
    storageData.removeItem("AddressChangeClass");
    storageData.removeItem("VehicleChangeID");
    storageData.removeItem("HouseholdChangeID");
    storageData.removeItem("AddressChangeID");
    storageData.removeItem("AddVehicleClass");
    storageData.removeItem("RemoveVehicleClass");
    storageData.removeItem("ReplaceVehicleClass");
    storageData.removeItem("responseData");
}

export const RemoveVehicleContextComp = ({ children }) => {
    const location = useLocation();
    const serverDate = useServerDate();

    const getTodaysDate = (addOne) => {
        // If adding a day --> seconds * minutes * hours * milliseconds
        var today = (addOne) ? new Date(new Date(serverDate).getTime() + (60 * 60 * 24 * 1000)) : new Date(serverDate)
        var yyyy = today.getFullYear()
        var mm = today.getMonth() + 1
        var dd = today.getDate()

        if (dd < 10) dd = '0' + dd
        if (mm < 10) mm = '0' + mm

        return mm + '/' + dd + '/' + yyyy
    }

    const [removeVehicleClass, setRemoveVehicleClass] = useState(JSON.parse(storageData.getItem("RemoveVehicleClass")))
    const [userData, setUserData] = useState(JSON.parse(storageData.getItem("userData")))
    const [submitEndorsementResponse, setSubmitEndorsementResponse] = useState()

    const [validationTitle, setValidationTitle] = useState("")
    const [validationMsg, setValidationMsg] = useState("")
    const [showModal, setShowModal] = useState(false)
    const setValidationMsgToggle = (title, value) => {
        setValidationTitle(title);
        setValidationMsg(value);
        setShowModal(true)
    }

    const [vinLoad, setVinLoad] = useState(false)
    const [submissionLoad, setSubmissionLoad] = useState(false)

    const updateVehiclesKeptOvernight = (key, value) => {
        var removeVehicleClassCopy = removeVehicleClass;
        removeVehicleClassCopy.driverAssignment[key] = value;

        // Assigns kept overnight value to each vehicle except for the one being removed
        removeVehicleClassCopy.driverAssignment.vehicles = removeVehicleClassCopy?.driverAssignment?.vehicles?.map(vehicle => ({
            ...vehicle,
            garaged: (value == "Yes") ? "1" : "0"
        }));
        setRemoveVehicleClass({ ...removeVehicleClassCopy });
        storageData.setItem("RemoveVehicleClass", JSON.stringify(removeVehicleClassCopy));
    }

    const updateDeleteStatus = (status) => {
        const updated = { ...removeVehicleClass, deleteStatus: status };
        setRemoveVehicleClass(updated);
        storageData.setItem("RemoveVehicleClass", JSON.stringify(updated));
    };

    const setGaragedToBit = (response) => {
        if (response == "No") { return "0" }
        else { return "1" }
    }

    return (
        <RemoveVehicleContext.Provider
            value={{
                removeVehicleClass, setRemoveVehicleClass,
                userData, setUserData,
                validationTitle, setValidationTitle,
                validationMsg, setValidationMsg,
                showModal, setShowModal,
                submitEndorsementResponse, setSubmitEndorsementResponse,
                setValidationMsgToggle,
                vinLoad, setVinLoad,
                submissionLoad, setSubmissionLoad,
                getTodaysDate,
                getStateAbbr,
                clear, updateVehiclesKeptOvernight,
                setGaragedToBit, updateDeleteStatus
            }}>
            {children}
        </RemoveVehicleContext.Provider>
    )
}
